import { render, staticRenderFns } from "./SalePage.vue?vue&type=template&id=206e9884&"
import script from "./SalePage.vue?vue&type=script&lang=js&"
export * from "./SalePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SalePage.vue"
export default component.exports